import { atom, atomWithPolling } from '@exodus/headless-ui';
import configAtom from './config.js';
import exchangeErrorAtom from './exchange-error.js';
import limitsAtom from './limits.js';
import toAssetAtom from './to-asset.js';
import { computePollInterval } from '../helpers/poll-interval.js';
import fromAssetAtom from './from-asset.js';
import fromWalletAccountAtom from './from-wallet-account.js';
import fromSpendableBalanceAtom from './from-spendable-balance.js';
import slippageAtom from './slippage.js';
const isSendAllAtom = atom(async (get) => {
    const balance = get(fromSpendableBalanceAtom);
    const limits = await get(limitsAtom);
    if (!limits)
        return false;
    return balance.gte(limits.ExactIn.min) && balance.lte(limits.ExactIn.max);
});
const amountAtom = atom(async (get) => {
    const balance = get(fromSpendableBalanceAtom);
    const isSendAll = await get(isSendAllAtom);
    const limits = await get(limitsAtom);
    if (!limits)
        return balance.toDefaultString();
    const amount = isSendAll ? balance : limits.ExactIn.max;
    return amount.toDefaultString();
});
const maxQuoteRequestAtom = atom(async (get) => {
    const fromAsset = get(fromAssetAtom);
    const isSendAll = await get(isSendAllAtom);
    const amount = fromAsset.currency.defaultUnit(await get(amountAtom));
    return {
        amount,
        fromAssetName: fromAsset.name,
        toAssetName: get(toAssetAtom).name,
        fromWalletAccount: get(fromWalletAccountAtom).toString(),
        isSendAll,
        slippage: get(slippageAtom),
    };
});
const buildMaxQuoteKey = (request) => [
    request.fromAssetName,
    request.toAssetName,
    request.amount.toBaseString(),
    request.fromWalletAccount,
    request.isSendAll,
    request.slippage,
].join('|');
const maxQuoteAtom = atomWithPolling(async (get, { exodus }) => {
    get(exchangeErrorAtom);
    const config = get(configAtom);
    const request = await get(maxQuoteRequestAtom);
    const quote = await exodus.exchange
        .getMaxQuote({ ...request, expiryMarginMs: config.expiryMarginMs })
        .catch(() => null);
    const interval = computePollInterval({
        expiry: quote?.expiry,
        expiryMarginMs: config.expiryMarginMs,
        defaultPollIntervalMs: config.defaultPollIntervalMs,
        stalePollIntervalMs: config.stalePollIntervalMs,
    });
    return { value: quote, interval };
});
maxQuoteAtom.cacheKey = async (get) => buildMaxQuoteKey(await get(maxQuoteRequestAtom));
export default maxQuoteAtom;
